"use client"

import { LayersPlus } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LayersPlusIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LayersPlusIcon = component(Icon)({ as: LayersPlus })
